export default __webpack_public_path__ + "static/media/bg.d1bb00d2.jpg";